import React from "react";
import PropTypes from "prop-types";
import { PrivateRoute } from "zina-dogi-react";
import { Redirect } from "react-router-dom";
import { utils } from "../utils";


export const PermisionRoute = ({ extraProps, path, component, codePerm, ...others }) => {
    const user = extraProps && extraProps.user;
    
    let Component = component;
    
    if (!user || !utils.user_has_perm(user, codePerm)) {
        Component = () => <Redirect to="/" />;
    }
    
    return <PrivateRoute extraProps={extraProps} path={path} component={Component} {...others} />;
};


PermisionRoute.propTypes = {
    codePerm: PropTypes.string.isRequired,
}